<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="main">
      <navMenu :active="active"></navMenu>
      <div class="content" v-loading.lock="loading">
        <div class="live-left">
          <el-menu
            :default-active="activeMenu"
            class="el-menu-vertical-demo"
            background-color="#ECEDF1"
            text-color="#222"
            active-text-color="#3C81E6"
            @select="handleSelect"
          >
            <el-submenu
              :index="String(index + 1)"
              v-for="(item, index) in navMenu"
              :key="index"
            >
              <template slot="title">
                <span>{{ item.title }}</span>
              </template>
              <el-menu-item-group>
                <el-menu-item
                  :index="_item.title"
                  v-for="(_item, _index) in item.items"
                  :key="_index"
                >
                  {{ _item.title }}</el-menu-item
                >
              </el-menu-item-group>
            </el-submenu>
          </el-menu>
        </div>
        <div class="live-right">
          <!-- 直播信息 -->
          <div v-show="activeMenu == '直播信息'" class="common-main">
            <div class="com-top flex-center-btw">
              <div class="title">直播背景</div>
              <div class="com-btn pointer" @click="showLiveLink">直播链接</div>
            </div>
            <div class="live-infor">
              <div class="live-tips">
                您的直播时间为：{{ liveInfor.starttime }} -
                {{ liveInfor.endtime }}，请做好直播前内容和设备的准备
              </div>
              <div class="live-list flex">
                <div class="live-title"><span>*</span> 直播封面：</div>
                <div class="live-upload">
                  <div style="display: flex">
                    <div class="image-wrap" v-if="liveInfor.thumb">
                      <div class="image">
                        <el-image
                          :src="$imgOssUrl + liveInfor.thumb"
                        ></el-image>
                        <div class="upload-span">
                          <span
                            class="upload-icon"
                            @click.stop="handleImgRemove"
                            ><i class="el-icon-delete"></i
                          ></span>
                        </div>
                      </div>
                    </div>

                    <div v-if="!liveInfor.thumb">
                      <el-upload
                        :action="$Url"
                        list-type="picture-card"
                        :headers="headers"
                        :multiple="false"
                        :on-success="handleImgsSuccess"
                        :on-error="handleImgsError"
                        :show-file-list="false"
                      >
                        <i class="el-icon-plus"></i>
                      </el-upload>
                    </div>
                  </div>
                  <div class="live-uptips">
                    <div>上传图片</div>
                    <div class="sub">请上传750*422px，4M以下的jpg/png文件</div>
                  </div>
                </div>
              </div>
              <div class="live-list flex-al-center">
                <div class="live-title">直播状态：</div>
                <div class="live-status">
                  <p v-if="liveStatus == 'unStart'">未开始</p>
                  <p v-if="liveStatus == 'live'">直播中</p>
                  <p v-if="liveStatus == 'end'">已结束</p>
                  <p v-if="liveStatus == 'waiting'">等待中</p>
                  <p v-if="liveStatus == 'playback'">回放中</p>
                  <p v-if="liveStatus == 'banpush'">已禁播</p>
                </div>
              </div>
            </div>
          </div>
          <!-- 直播介绍 -->
          <div v-show="activeMenu == '直播介绍'" class="common-main">
            <div class="com-top flex-center-btw">
              <div class="title">直播介绍</div>
              <div class="com-btn pointer" @click="savehtml">保存</div>
            </div>
            <div style="margin-top: 20px">
              <editor v-model="content" :border="true" />
            </div>
          </div>
          <!-- 角色设置 -->
          <div v-show="activeMenu == '角色设置'" class="common-main">
            <div class="com-top flex-center-btw">
              <div class="title">角色设置</div>
              <div class="com-btn pointer" @click="showLiveLink">直播链接</div>
            </div>
            <div class="role-set">
              <div class="set-common">
                <div class="set-title">
                  主讲设置
                  <span
                    ><i class="el-icon-warning-outline"></i
                    >讲师：唯一角色，一个直播间只有一个讲师，负责上课和管理直播间信息</span
                  >
                </div>
                <el-table
                  :data="tableData"
                  style="width: 100%"
                  :header-cell-style="{
                    'text-align': 'center',
                    background: '#EDF1F7',
                  }"
                  :cell-style="{ 'text-align': 'center' }"
                >
                  <template slot="empty">
                    <img
                      style="width: 100px; margin: 40px auto 10px"
                      src="../assets/nodata.jpg"
                      alt=""
                      srcset=""
                    />
                  </template>
                  <el-table-column prop="avatar" label="头像">
                    <template slot-scope="scope">
                      <el-image
                        style="width: 48px; height: 48px; border-radius: 50%"
                        :src="scope.row.avatar"
                        fit="cover"
                      >
                      </el-image>
                    </template>
                  </el-table-column>
                  <el-table-column prop="actor" label="头衔"> </el-table-column>
                  <el-table-column prop="nickname" label="昵称">
                  </el-table-column>
                  <el-table-column prop="account" label="账号">
                  </el-table-column>
                  <el-table-column prop="passwd" label="密码">
                  </el-table-column>
                  <el-table-column fixed="right" label="操作" width="200">
                    <template slot-scope="scope">
                      <!-- https://live.polyv.net/web-start/login?channelId=<?= $_GET['channelId']; ?>  -->
                      <el-button
                        type="text"
                        size="medium"
                        @click="
                          copyLink(
                            `https://live.polyv.net/web-start/login?channelId=${scope.row.account}`
                          )
                        "
                        >复制链接</el-button
                      >
                      <el-button
                        @click="roleSetClick('1', scope.row)"
                        type="text"
                        size="medium"
                        >编辑</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="set-common">
                <div class="set-title flex-center-btw">
                  助教设置
                  <span style="flex: 1"
                    ><i class="el-icon-warning-outline"></i
                    >助教：使用子频道登录助教管理后台，能够观看直播、参与互动、进行聊天室管理，发送图文直播，监控直播等操作</span
                  >
                  <span class="set-btn pointer" @click="roleSetClick('4')"
                    >添加助教</span
                  >
                </div>
                <el-table
                  :data="roleAssistantData"
                  style="width: 100%"
                  :header-cell-style="{
                    'text-align': 'center',
                    background: '#EDF1F7',
                  }"
                  :cell-style="{ 'text-align': 'center' }"
                >
                  <template slot="empty">
                    <img
                      style="width: 100px; margin: 40px auto 10px"
                      src="../assets/nodata.jpg"
                      alt=""
                      srcset=""
                    />
                  </template>
                  <el-table-column prop="avatar" label="头像">
                    <template slot-scope="scope">
                      <el-image
                        style="width: 48px; height: 48px; border-radius: 50%"
                        :src="scope.row.avatar"
                        fit="cover"
                      >
                      </el-image>
                    </template>
                  </el-table-column>
                  <el-table-column prop="actor" label="头衔"> </el-table-column>
                  <el-table-column prop="nickname" label="昵称">
                  </el-table-column>
                  <el-table-column prop="account" label="账号">
                  </el-table-column>
                  <el-table-column prop="passwd" label="密码">
                  </el-table-column>
                  <el-table-column fixed="right" label="操作" width="200">
                    <template slot-scope="scope">
                      <el-button
                        type="text"
                        size="medium"
                        @click="
                          copyLink(
                            `https://console.polyv.net/live/login.html?channelId=${scope.row.account}`
                          )
                        "
                        >复制链接</el-button
                      >
                      <el-button
                        @click="roleSetClick('2', scope.row)"
                        type="text"
                        size="medium"
                        >编辑</el-button
                      >
                      <el-button
                        type="text"
                        style="color: #fe1c1c"
                        size="medium"
                        @click="delAccount(scope.row)"
                        >删除</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="set-common">
                <div class="set-title flex-center-btw">
                  嘉宾设置
                  <span style="flex: 1"
                    ><i class="el-icon-warning-outline"></i
                    >嘉宾：讲师和嘉宾可同时讲一堂课，支持连麦互动，需要使用最新开播端登录</span
                  >
                  <span class="set-btn pointer" @click="roleSetClick('5')"
                    >添加嘉宾</span
                  >
                </div>
                <el-table
                  :data="roleGuestData"
                  style="width: 100%"
                  :header-cell-style="{
                    'text-align': 'center',
                    background: '#EDF1F7',
                  }"
                  :cell-style="{ 'text-align': 'center' }"
                >
                  <template slot="empty">
                    <img
                      style="width: 100px; margin: 40px auto 10px"
                      src="../assets/nodata.jpg"
                      alt=""
                      srcset=""
                    />
                  </template>
                  <el-table-column prop="avatar" label="头像">
                    <template slot-scope="scope">
                      <el-image
                        style="width: 48px; height: 48px; border-radius: 50%"
                        :src="scope.row.avatar"
                        fit="cover"
                      >
                      </el-image>
                    </template>
                  </el-table-column>
                  <el-table-column prop="actor" label="头衔"> </el-table-column>
                  <el-table-column prop="nickname" label="昵称">
                  </el-table-column>
                  <el-table-column prop="account" label="账号">
                  </el-table-column>
                  <el-table-column prop="passwd" label="密码">
                  </el-table-column>
                  <el-table-column fixed="right" label="操作" width="200">
                    <template slot-scope="scope">
                      <!-- https://live.polyv.net/web-start/guest?channelId=/  -->
                      <el-button
                        type="text"
                        size="medium"
                        @click="
                          copyLink(
                            `https://live.polyv.net/web-start/guest?channelId=${scope.row.account}`
                          )
                        "
                        >复制链接</el-button
                      >
                      <el-button
                        @click="roleSetClick('3', scope.row)"
                        type="text"
                        size="medium"
                        >编辑</el-button
                      >
                      <el-button
                        type="text"
                        style="color: #fe1c1c"
                        size="medium"
                        @click="delAccount(scope.row)"
                        >删除</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
          <!-- 直播产品 -->
          <div
            v-show="activeMenu == '直播产品'"
            class="common-main"
            style="min-height: calc(100% - 70px)"
          >
            <div class="com-top flex-center-btw">
              <div class="title">直播产品</div>
              <div class="com-btn pointer" @click="showLiveLink">直播链接</div>
            </div>
            <div class="goods-content">
              <div class="goods-top flex-al-center">
                <span class="goods-title">商品列表：</span>
                <el-switch
                  style="display: block"
                  v-model="goodsSwitch"
                  @change="updateProductEnabled"
                >
                </el-switch>
                <div class="tips flex-al-center">
                  <i class="el-icon-warning-outline"></i
                  >开启后，观看页将展示商品列表
                </div>
              </div>
              <div class="add-goods flex-al-center">
                <div class="add-btn pointer" @click="editProduct('add')">
                  选择商品
                </div>
                <div class="tips flex-al-center">
                  <i class="el-icon-warning-outline"></i
                  >请在直播前添加完商品并调整好顺序
                </div>
              </div>
              <el-table
                :data="goodsList.contents"
                style="width: 100%"
                :header-cell-style="{
                  'text-align': 'center',
                  background: '#EDF1F7',
                }"
                :cell-style="{ 'text-align': 'center' }"
                @selection-change="multipleSelect"
              >
                <template slot="empty">
                  <img
                    style="width: 100px; margin: 40px auto 10px"
                    src="../assets/nodata.jpg"
                    alt=""
                    srcset=""
                  />
                </template>
                <el-table-column
                  prop="productId"
                  label="商品ID"
                ></el-table-column>
                <el-table-column prop="firstImage" label="封面" width="100">
                  <template slot-scope="scope">
                    <el-image
                      style="width: 88px; height: 88px; border-radius: 18px"
                      :src="scope.row.cover"
                      fit="cover"
                    >
                    </el-image>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="name"
                  label="名称"
                  min-width="200"
                ></el-table-column>
                <el-table-column
                  prop="productType"
                  label="类型"
                  min-width="100"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.productType == 'normal'"
                      >普通商品</span
                    >
                    <span v-if="scope.row.productType == 'finance'"
                      >金融商品</span
                    >
                  </template>
                </el-table-column>
                <el-table-column prop="status" label="上架状态" width="100">
                  <template slot-scope="scope">
                    <el-switch
                      v-model="scope.row.status"
                      :active-value="1"
                      :inactive-value="2"
                      @change="changeProductStatus($event, scope.row)"
                    ></el-switch>
                  </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="200">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      :disabled="scope.$index == 0 ? true : false"
                      size="medium"
                      @click="sortProduct(scope.row, '10')"
                      >上移</el-button
                    >
                    <el-button
                      type="text"
                      :disabled="
                        scope.$index == goodsList.contents.length - 1
                          ? true
                          : false
                      "
                      size="medium"
                      @click="sortProduct(scope.row, '20')"
                      >下移</el-button
                    >
                    <el-button
                      type="text"
                      :disabled="scope.row.isPush ? true : false"
                      size="medium"
                      @click="pushProduct(scope.row, scope.$index)"
                      >推送</el-button
                    >
                    <el-button
                      type="text"
                      style="color: #fe1c1c"
                      size="medium"
                      @click="delGoods(scope.row)"
                      >删除</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <el-pagination
              background
              class="main-page"
              layout="total, prev, pager, next"
              :current-page="goodsPage"
              :total="goodsTotal"
              @current-change="goodsChange"
            >
            </el-pagination>
          </div>
          <!-- 数据统计 -->
          <div v-show="activeMenu == '数据统计'" class="common-main">
            <div class="com-top flex-center-btw">
              <div class="title">数据统计</div>
              <div class="com-btn pointer" @click="showLiveLink">直播链接</div>
            </div>
            <div class="stats-wrap flex-al-center">
              <div class="stats-item">
                <div>访问人数(人)</div>
                <div class="stats-num">{{ statsObj.uniqueVisitor }}</div>
              </div>
              <div class="stats-item">
                <div>观看次数(次)</div>
                <div class="stats-num">{{ statsObj.plays }}</div>
              </div>
              <div class="stats-item">
                <div>观看时长(分钟)</div>
                <div class="stats-num">{{ statsObj.playDuration }}</div>
              </div>
              <div class="stats-item">
                <div>观看人数(人)</div>
                <div class="stats-num">{{ statsObj.viewers }}</div>
              </div>
              <div class="stats-item">
                <div>人均观看时长(分钟)</div>
                <div class="stats-num">{{ statsObj.averagePlayDuration }}</div>
              </div>
              <div class="stats-item">
                <div>人均观看次数(次)</div>
                <div class="stats-num">{{ statsObj.averageTime }}</div>
              </div>
            </div>
          </div>
          <!-- 视频库 -->
          <div v-show="activeMenu == '视频库'" class="common-main">
            <div class="com-top flex-center-btw">
              <div class="title">视频库</div>
              <div class="com-btn pointer" @click="showLiveLink">直播链接</div>
            </div>
            <el-tabs
              class="video-main"
              v-model="videoActiveName"
              @tab-click="liveHandleClick"
            >
              <el-tab-pane label="直播暂存" name="直播暂存">
                <div class="top flex-al-center">
                  <div class="tips flex">
                    <i class="el-icon-warning-outline"></i
                    >直播暂存视频文件只保留180天，如需永久保留请转存至回放列表裁剪或合并后生成新视频，原视频不受影响
                  </div>
                  <div class="top-btn pointer">
                    <span @click="refresh">刷新</span>
                    <span class="top-add" @click="addLiveList"
                      >添加至回放列表</span
                    >
                    <span class="top-del" @click="recordFilesDel">删除</span>
                  </div>
                </div>
                <el-table
                  :data="recordFilesData"
                  style="width: 100%"
                  :header-cell-style="{
                    'text-align': 'center',
                    background: '#EDF1F7',
                  }"
                  :cell-style="{ 'text-align': 'center' }"
                  @selection-change="multipleSelect"
                >
                  <template slot="empty">
                    <img
                      style="width: 100px; margin: 40px auto 10px"
                      src="../assets/nodata.jpg"
                      alt=""
                      srcset=""
                    />
                  </template>
                  <el-table-column type="selection" width="55">
                  </el-table-column>
                  <el-table-column
                    prop="channelSessionId"
                    label="场次ID"
                    width="200"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="startTime"
                    label="直播开始时间"
                    width="200"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="recordFileType"
                    label="视频类型"
                    width="150"
                  >
                    <template slot-scope="scope">
                      <span
                        class="video-type"
                        v-if="scope.row.recordFileType == 'complete'"
                        >完整回放</span
                      >
                      <span
                        class="video-type type-green"
                        v-if="scope.row.recordFileType == 'part'"
                        >自动录制_片段</span
                      >
                      <span
                        class="video-type type-blue"
                        v-if="scope.row.recordFileType == 'merge'"
                        >手动合并</span
                      >
                      <span
                        class="video-type type-purple"
                        v-if="scope.row.recordFileType == 'clip'"
                        >裁剪</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column prop="fileName" label="视频名称">
                  </el-table-column>
                  <el-table-column prop="duration" label="视频时长" width="100">
                  </el-table-column>
                  <el-table-column
                    prop="daysLeft"
                    label="暂存剩余天数"
                    width="150"
                  >
                  </el-table-column>
                  <el-table-column fixed="right" label="操作" width="150">
                    <template slot-scope="scope">
                      <a :href="scope.row.url"
                        ><el-button type="text" size="medium"
                          >下载</el-button
                        ></a
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </el-tab-pane>
              <el-tab-pane label="回放列表" name="回放列表">
                <div class="top flex-al-center">
                  <div class="tips flex">
                    <i class="el-icon-warning-outline"></i
                    >回放视频转入回放列表需要一定的转码时间，请耐心等待。
                  </div>
                  <div class="top-btn pointer">
                    <span class="top-del" @click="deletePlayback">删除</span>
                  </div>
                </div>
                <el-table
                  :data="playBackList.contents"
                  style="width: 100%"
                  :header-cell-style="{
                    'text-align': 'center',
                    background: '#EDF1F7',
                  }"
                  :cell-style="{ 'text-align': 'center' }"
                  @selection-change="multipleSelect"
                >
                  <template slot="empty">
                    <img
                      style="width: 100px; margin: 40px auto 10px"
                      src="../assets/nodata.jpg"
                      alt=""
                      srcset=""
                    />
                  </template>
                  <el-table-column type="selection" width="55">
                  </el-table-column>
                  <el-table-column prop="firstImage" label="缩略图" width="150">
                    <template slot-scope="scope">
                      <el-image
                        style="width: 120px; height: 68px"
                        :src="scope.row.firstImage"
                        fit="cover"
                      >
                      </el-image>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="title"
                    label="视频名称"
                  ></el-table-column>
                  <el-table-column
                    prop="duration"
                    label="视频时长"
                    width="200"
                  ></el-table-column>
                  <el-table-column
                    prop="startTime"
                    label="直播开始时间"
                    width="200"
                  ></el-table-column>
                  <el-table-column
                    prop="channelSessionId"
                    label="场次ID"
                    width="200"
                  ></el-table-column>
                  <el-table-column fixed="right" label="操作" width="150">
                    <template slot-scope="scope">
                      <a :href="scope.row.url"
                        ><el-button type="text" size="medium"
                          >下载</el-button
                        ></a
                      >
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  background
                  class="main-page"
                  layout="total, prev, pager, next"
                  :total="playBackList.totalItems"
                  :current-page="playBackPage"
                  @current-change="playBackChange"
                ></el-pagination>
              </el-tab-pane>
              <el-tab-pane label="点播列表" name="点播列表">
                <div class="top flex-al-center">
                  <div class="tips flex">
                    <i class="el-icon-warning-outline"></i
                    >点播列表仅支持直播结束后转存的视频，暂不支持flash
                  </div>
                  <div class="top-btn pointer">
                    <span class="top-del" @click="deletePlayback">删除</span>
                  </div>
                </div>
                <el-table
                  :data="vodList.contents"
                  style="width: 100%"
                  :header-cell-style="{
                    'text-align': 'center',
                    background: '#EDF1F7',
                  }"
                  :cell-style="{ 'text-align': 'center' }"
                  @selection-change="multipleSelect"
                >
                  <template slot="empty">
                    <img
                      style="width: 100px; margin: 40px auto 10px"
                      src="../assets/nodata.jpg"
                      alt=""
                      srcset=""
                    />
                  </template>
                  <el-table-column type="selection" width="55">
                  </el-table-column>
                  <el-table-column
                    prop="title"
                    label="视频名称"
                    width="300"
                  ></el-table-column>
                  <el-table-column
                    prop="videoPoolId"
                    label="vid"
                    min-width="350"
                  ></el-table-column>
                  <el-table-column
                    prop="duration"
                    label="视频时长"
                    width="200"
                  ></el-table-column>
                  <el-table-column label="状态" width="200">
                    <template slot-scope="scope">
                      {{ scope.row.duration != "" ? "已完成" : "未完成" }}
                    </template>
                  </el-table-column>
                  <el-table-column fixed="right" label="操作" width="150">
                    <template slot-scope="scope">
                      <a :href="scope.row.url"
                        ><el-button type="text" size="medium"
                          >下载</el-button
                        ></a
                      >
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  background
                  class="main-page"
                  layout="total, prev, pager, next"
                  :total="vodList.totalItems"
                  :current-page="playBackPage"
                  @current-change="playBackChange"
                ></el-pagination>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
      <!-- 直播链接弹框 -->
      <div class="live-link" v-if="isShowLiveLink">
        <div class="link-main">
          <div class="link-top flex-center-btw">
            直播链接
            <i
              class="el-icon-close pointer"
              @click="isShowLiveLink = false"
            ></i>
          </div>
          <div class="link-content">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane
                v-for="(item, index) in linkList"
                :key="index"
                :label="item"
                :name="item"
              ></el-tab-pane>
            </el-tabs>
            <div v-if="activeName == '主讲'">
              <div class="input-list flex-center-btw">
                <div class="link-label">网页开播链接：</div>
                <div class="link-input">
                  <el-input
                    :value="`https://live.polyv.net/web-start/classroom?channelId=${channelId}`"
                    readonly
                    placeholder="请输入网页开播链接"
                  ></el-input>
                </div>
                <div class="link-btn pointer">
                  <a
                    :href="`https://live.polyv.net/web-start/classroom?channelId=${channelId}`"
                    target="_blank"
                    ><span>打开</span></a
                  >
                  |
                  <span
                    @click="
                      copyLink(
                        `https://live.polyv.net/web-start/classroom?channelId=${channelId}`
                      )
                    "
                    >复制</span
                  >
                </div>
              </div>
              <div class="input-list flex-center-btw">
                <div class="link-label">启动客户端链接：</div>
                <div class="link-input">
                  <el-input
                    :value="`https://console.polyv.net/live/start-client.html?channelId=${
                      tableData.length > 0 ? tableData[0].account : ''
                    }`"
                    placeholder="请输入启动客户端链接："
                    readonly
                  ></el-input>
                </div>
                <div class="link-btn pointer">
                  <a
                    :href="`https://console.polyv.net/live/start-client.html?channelId=${
                      tableData.length > 0 ? tableData[0].account : ''
                    }`"
                    target="_blank"
                    ><span>打开</span></a
                  >
                  |
                  <span
                    @click="
                      copyLink(
                        `https://console.polyv.net/live/start-client.html?channelId=${
                          tableData.length > 0 ? tableData[0].account : ''
                        }`
                      )
                    "
                    >复制</span
                  >
                </div>
              </div>
              <div class="input-list flex-center-btw">
                <div class="link-label"></div>
                <div class="link-input flex">
                  <div class="span">
                    频道号：<span v-if="tableData.length > 0">{{
                      tableData.length > 0 ? tableData[0].account : ""
                    }}</span>
                  </div>
                  <div class="span">
                    密码/邀请码：<span v-if="tableData.length > 0">{{
                      tableData.length > 0 ? tableData[0].passwd : ""
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="activeName == '助教'">
              <div class="input-list flex-center-btw">
                <div class="link-label">助教后台链接：</div>
                <div class="link-input">
                  <el-input
                    :value="`https://console.polyv.net/live/login.html?channelId=${
                      roleAssistantData.length > 0
                        ? roleAssistantData[0].account
                        : ''
                    }`"
                    readonly
                    placeholder=""
                  ></el-input>
                </div>
                <div class="link-btn pointer">
                  <a
                    :href="`https://console.polyv.net/live/login.html?channelId=${
                      roleAssistantData.length > 0
                        ? roleAssistantData[0].account
                        : ''
                    }`"
                    target="_blank"
                    ><span>打开</span></a
                  >
                  |
                  <span
                    @click="
                      copyLink(
                        `https://console.polyv.net/live/login.html?channelId=${
                          roleAssistantData.length > 0
                            ? roleAssistantData[0].account
                            : ''
                        }`
                      )
                    "
                    >复制</span
                  >
                </div>
              </div>
              <div class="input-list flex-center-btw">
                <div class="link-label"></div>
                <div class="link-input flex">
                  <div class="span">
                    频道号：<span v-if="roleAssistantData.length > 0">{{
                      roleAssistantData.length > 0
                        ? roleAssistantData[0].account
                        : ""
                    }}</span>
                  </div>
                  <div class="span">
                    密码/邀请码：<span v-if="roleAssistantData.length > 0">{{
                      roleAssistantData.length > 0
                        ? roleAssistantData[0].passwd
                        : ""
                    }}</span>
                  </div>
                  <div
                    class="span pointer"
                    @click="toRoleSet"
                    style="margin-right: 0; color: #3c81e6"
                  >
                    查看其他助教
                  </div>
                </div>
              </div>
            </div>
            <div v-if="activeName == '嘉宾'">
              <div class="input-list flex-center-btw">
                <div class="link-label">网页开播链接：</div>
                <div class="link-input">
                  <el-input
                    :value="`https://live.polyv.net/web-start/guest?channelId=${
                      roleGuestData.length > 0 ? roleGuestData[0].account : ''
                    }`"
                    readonly
                    placeholder=""
                  ></el-input>
                </div>
                <div class="link-btn pointer">
                  <a
                    :href="`https://live.polyv.net/web-start/guest?channelId=${
                      roleGuestData.length > 0 ? roleGuestData[0].account : ''
                    }`"
                    target="_blank"
                    ><span>打开</span></a
                  >
                  |
                  <span
                    @click="
                      copyLink(
                        `https://live.polyv.net/web-start/guest?channelId=${
                          roleGuestData.length > 0
                            ? roleGuestData[0].account
                            : ''
                        }`
                      )
                    "
                    >复制</span
                  >
                </div>
              </div>
              <div class="input-list flex-center-btw">
                <div class="link-label"></div>
                <div class="link-input flex">
                  <div class="span">
                    频道号：<span v-if="roleGuestData.length > 0">{{
                      roleGuestData.length > 0 ? roleGuestData[0].account : ""
                    }}</span>
                  </div>
                  <div class="span">
                    密码/邀请码：<span v-if="roleGuestData.length > 0">{{
                      roleGuestData.length > 0 ? roleGuestData[0].passwd : ""
                    }}</span>
                  </div>
                  <div
                    class="span pointer"
                    @click="toRoleSet"
                    style="margin-right: 0; color: #3c81e6"
                  >
                    查看其他嘉宾
                  </div>
                </div>
              </div>
            </div>
            <div v-if="activeName == '观众'">
              <div class="input-list flex-center-btw">
                <div class="link-label">观众观看链接：</div>
                <div class="link-input">
                  <el-input
                    :value="`https://live.polyv.cn/watch/${channelId}`"
                    readonly
                  ></el-input>
                </div>
                <div class="link-btn pointer">
                  <a
                    :href="`https://live.polyv.cn/watch/${channelId}`"
                    target="_blank"
                    ><span>打开</span></a
                  >
                  |
                  <span
                    @click="
                      copyLink(`https://live.polyv.cn/watch/${channelId}`)
                    "
                    >复制</span
                  >
                </div>
              </div>
              <div class="input-list flex">
                <div class="link-label">移动端H5观看：</div>
                <div class="link-input flex">
                  <div
                    id="qrcode"
                    class="qrcode"
                    style="
                      width: 80px;
                      height: 80px;
                      border: 1px solid #ccc;
                      padding: 10px;
                    "
                  ></div>
                </div>
              </div>
            </div>
            <div v-if="activeName == '第三方推流'">
              <div class="input-list flex-center-btw">
                <div class="link-label">推流链接：</div>
                <div class="link-input">
                  <el-input v-model="streamingLink"></el-input>
                </div>
                <div class="link-btn pointer">
                  <span @click="copyLink(streamingLink)">复制</span>
                </div>
              </div>
              <div style="color: #666; font-size: 14px; margin: 20px 0 0 140px">
                <i class="el-icon-warning-outline"></i>
                推流地址30分钟内推上有效，超过30分钟未推流，请刷新后台获取最新推流地址
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 角色设置弹框 -->
      <div class="role-wrap" v-if="isShowRoleSet">
        <div class="role-main">
          <div class="role-top flex-center-btw">{{ roleTitle }}</div>
          <div class="role-content">
            <el-form ref="roleForm" :model="roleForm" label-width="150px">
              <el-form-item label="头衔：">
                <el-input
                  v-model="roleForm.actor"
                  maxlength="10"
                  show-word-limit
                ></el-input>
              </el-form-item>
              <el-form-item label="昵称：">
                <el-input
                  v-model="roleForm.nickname"
                  maxlength="15"
                  show-word-limit
                ></el-input>
              </el-form-item>
              <el-form-item label="密码：">
                <el-input
                  v-model="roleForm.passwd"
                  maxlength="16"
                  show-word-limit
                ></el-input>
              </el-form-item>
              <el-form-item
                label="角色头像："
                class="role-upload"
                prop="avatar"
              >
                <div class="image" v-if="roleForm.avatar">
                  <el-image :src="roleForm.avatar"></el-image>
                  <div class="upload-span">
                    <span class="upload-icon" @click.stop="handleRemove()"
                      ><i class="el-icon-delete"></i
                    ></span>
                  </div>
                </div>

                <div v-if="!roleForm.avatar">
                  <el-upload
                    :action="$Url"
                    list-type="picture-card"
                    :headers="headers"
                    :multiple="false"
                    :on-success="handleLogoSuccess"
                    :on-error="handleLogoError"
                    :show-file-list="false"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                </div>
                <div style="width: 100%; color: #666; font-size: 13px">
                  请上传 140*140px的图标，文件大小不超过2M
                </div>
              </el-form-item>
              <el-divider></el-divider>
              <el-form-item class="role-btn">
                <el-button type="primary" @click="roleSubmit">保存</el-button>
                <el-button @click="isShowRoleSet = false">取消</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <!-- 添加产品弹框 -->
      <div class="role-wrap goods-wrap" v-if="isShowGoods">
        <div class="role-main">
          <div class="role-top flex-center-btw">选择产品</div>
          <el-scrollbar style="height: 500px; width: 100%">
            <div class="role-content">
              <el-form
                ref="goodsForm"
                :model="goodsForm"
                :rules="goodsRules"
                label-width="150px"
              >
                <table class="cloumtable">
                  <tr class="grid">
                    <th style="width: 5%"></th>
                    <th style="width: 20%">产品照片</th>
                    <th style="width: 20%">产品名称</th>
                    <th style="width: 15%">产品分类</th>
                    <th style="width: 20%">产品规格</th>
                    <th style="width: 20%">生产厂家</th>
                  </tr>
                  <tr
                    class="gridval"
                    v-for="(item, index) in productList"
                    :key="index"
                  >
                    <td>
                      <input
                        type="checkbox"
                        :id="item.checked"
                        v-model="item.checked"
                        :value="item.checked"
                        @click="currentCheck($event, item)"
                      />
                    </td>
                    <td style="width: 20%">
                      <img class="cptp" :src="item.imgs[0]" />
                    </td>
                    <td style="width: 20%">{{ item.goodsName }}</td>
                    <td style="width: 15%">{{ item.category }}</td>
                    <td style="width: 20%">{{ item.specifications }}</td>
                    <td style="width: 20%">{{ item.producer }}</td>
                  </tr>
                </table>
                <el-form-item class="role-btn">
                  <el-button type="primary" @click="goodsSubmit"
                    >保存</el-button
                  >
                  <el-button @click="isShowGoods = false">取消</el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <!-- 转存信息填写 -->
      <div class="role-wrap video-wrap" v-if="isShowVideo">
        <div class="role-main">
          <div class="role-top flex-center-btw">转存信息填写</div>
          <div class="role-content">
            <el-form ref="videoForm" :model="videoForm" label-width="150px">
              <el-form-item label="视频名称：">
                <el-input
                  v-model="videoForm.name"
                  placeholder="请输入转存后视频名称"
                ></el-input>
              </el-form-item>
              <el-divider></el-divider>
              <el-form-item class="role-btn">
                <el-button type="primary" @click="liveSubmit()">保存</el-button>
                <el-button @click="isShowVideo = false">取消</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  polyvDetail,
  polyvLiveStatus,
  polyvGetTeacherInfo,
  polyvGetAccounts,
  polyvPushUrl,
  polyvAddChannelAccount,
  updateTeacher,
  updateAccount,
  deleteAccount,
  polyvStatistic,
  polyvProductList,
  productList,
  polyvAddProduct,
  polyvProductEnabled,
  polyvUpdateProductEnabled,
  polyvProductShelf,
  polyvSortProduct,
  polyvPushProduct,
  deleteProduct,
  polyvRecordFiles,
  polyvPlayback,
  polyvConvert,
  deleteRecord,
  deletePlayback,
  polyvDecorate,
  updateDecorate,
} from "@/api/api";
import top from "../components/top.vue"; //头部
import navMenu from "../components/navMenu.vue"; //左侧步骤条
import editor from "../components/wangEditor.vue";
import moment from "moment";
import QRCode from "qrcodejs2";

export default {
  components: { top, navMenu, editor },
  name: "liveSet",
  data() {
    return {
      content: "",
      loading: false,
      active: 3,
      activeMenu: "直播信息", //当前选中菜单
      navMenu: [
        {
          title: "直播管理",
          items: [
            { title: "直播信息", url: "" },
            { title: "直播介绍", url: "" },
            { title: "角色设置", url: "" },
            { title: "直播产品", url: "" },
          ],
        },
        {
          title: "直播统计",
          items: [{ title: "数据统计", url: "" }],
        },
        {
          title: "直播回放",
          items: [{ title: "视频库", url: "" }],
        },
      ],
      liveInfor: {}, //直播信息
      liveStatus: "", // 直播状态
      headers: {},
      isShowLiveLink: false,
      linkList: ["主讲", "助教", "嘉宾", "观众", "第三方推流"], //直播链接
      activeName: "主讲",
      tableData: [], // 角色设置-主讲
      roleAssistantData: [], // 角色设置-助教
      roleGuestData: [], // 角色设置-嘉宾
      roleForm: {
        actor: "",
        nickname: "",
        passwd: "",
        avatar: "",
      }, //角色表单
      streamingLink: "",
      roleTitle: "编辑主讲",
      isShowRoleSet: false, //是否显示角色弹框
      statsObj: {}, // 数据统计
      goodsSwitch: "", // 商品开关
      goodsForm: {
        productId: "",
        productType: "normal",
        cover: [],
        name: "",
        price: "0",
        realPrice: "0",
        features: [],
        yield: "",
        productDesc: "",
        linkType: "10",
        link: "",
        pcLink: "",
        mobileLink: "",
        wxMiniprogramOriginalId: "",
        wxMiniprogramLink: "",
        mobileAppLink: "",
        status: "1",
        btnShow: "",
      },
      goodsRules: {
        productType: [
          { required: true, message: "请选择类型", trigger: "blur" },
        ],
        name: [{ required: true, message: "请输入商品名称", trigger: "blur" }],
        realPrice: [
          { required: true, message: "请输入购买价格", trigger: "blur" },
        ],
        link: [{ required: true, message: "请输入链接", trigger: "blur" }],
        goodslink: [
          { required: true, message: "请输入商品链接", trigger: "blur" },
        ],
        status: [
          { required: true, message: "请选择商品状态", trigger: "blur" },
        ],
        btnShow: [
          { required: false, message: "请输入按钮文案", trigger: "blur" },
        ],
      },
      isShowGoods: false,
      goodsList: {}, // 商品数据
      goodsPage: 1, //商品分页
      goodsTotal: 0,
      linkOptions: [
        { value: "10", label: "通用链接" },
        { value: "11", label: "多平台链接" },
      ], //商品链接选项
      multipleSelectData: [], // 多选选中数据
      productData: {}, // 当前选中的商品数据
      playBackPage: 1,
      playType: "",
      isShowVideo: false,
      videoActiveName: "直播暂存",
      recordFilesData: [], // 暂存列表
      playBackList: {}, // 回放列表
      vodList: {}, // 点播列表
      videoForm: {
        name: "",
      },
    };
  },
  mounted() {
    let stepMenuList = JSON.parse(localStorage.getItem("menu"));
    this.stepMenuList = stepMenuList;
    var index = stepMenuList.findIndex(function (item) {
      return item.link_url == "liveList";
    });
    this.active = index;
    let token = localStorage.getItem("token");
    this.headers = {
      token: token,
    };
    this.id = this.$route.query.id;
    this.channelId = this.$route.query.channelId;
    let activeMenu = localStorage.getItem("activeMenu");
    if (activeMenu) {
      this.handleSelect(activeMenu);
    } else {
      // 获取直播信息
      this.getLiveInfor();
      this.getLiveStatus();
    }
    // 获取主讲信息
    this.getRoleSet(this.channelId);
    // 获取助教／嘉宾信息
    this.getRoleSetList(this.channelId);
    //第三方推流
    this.getStreamingLink();
    //获取产品列表
    this.getProductlist();
    //获取直播介绍
    this.getDecorate();
  },
  created() {},
  methods: {
    //选择菜单
    handleSelect(key) {
      console.log(key, "==key");
      let { id, channelId } = this;
      this.activeMenu = key;
      localStorage.setItem("activeMenu", this.activeMenu);
      switch (key) {
        case "直播信息":
          // 获取直播信息
          this.getLiveInfor();
          // 获取直播状态
          this.getLiveStatus();
          break;
        case "角色设置":
          // 获取主讲信息
          this.getRoleSet(channelId);
          // 获取助教／嘉宾信息
          this.getRoleSetList(channelId);
          break;
        case "直播产品":
          // 商品库开关状态
          this.getProductEnabled();
          // 商品列表
          this.getGoodsList();
          break;
        case "数据统计":
          // 数据统计
          this.getStatistic(channelId);
          break;
        case "视频库":
          // 视频库
          this.getRecordFiles(channelId);
          break;
        default:
          console.log("===菜单===");
      }
    },
    showLiveLink() {
      this.isShowLiveLink = true;
    },
    //获取直播信息
    getLiveInfor() {
      let data = this.$qs.stringify({
        id: this.id,
      });
      polyvDetail(data)
        .then((res) => {
          if (res.data.code == 1) {
            let { data } = res.data;
            data.starttime = moment(data.starttime * 1000).format(
              "YYYY-MM-DD HH:mm:ss"
            );
            data.endtime = moment(data.endtime * 1000).format(
              "YYYY-MM-DD HH:mm:ss"
            );
            this.liveInfor = data;
          }
        })
        .catch((err) => {});
    },
    //获取直播状态
    getLiveStatus() {
      let data = this.$qs.stringify({
        channelIds: this.channelId,
      });
      polyvLiveStatus(data)
        .then((res) => {
          if (res.data.code == 1) {
            console.log(res.data.data);
            this.liveStatus = res.data.data[0].liveStatus;
          }
        })
        .catch((err) => {});
    },
    //直播封面上传成功
    handleImgsSuccess(resData, file, fileList) {
      this.liveInfor.thumb = resData.data.url;
    },
    // 直播封面上传失败
    handleImgsError(err, file, fileList) {
      this.$message.error(err.message);
    },
    //直播封面删除
    handleImgRemove(index) {
      this.liveInfor.thumb = "";
    },
    //获取直播介绍
    getDecorate() {
      polyvDecorate(this.channelId)
        .then((res) => {
          if (res.data.code == 1) {
            this.content = res.data.data.content;
          } else {
            this.content = "";
          }
        })
        .catch((err) => {});
    },
    //直播介绍
    savehtml() {
      updateDecorate({
        channelId: this.channelId,
        content: this.content,
      })
        .then((res) => {
          if (res.data.code == 1) {
            this.$message.success("保存成功！");
          } else {
            this.$message.warning(res.data.msg);
          }
        })
        .catch((err) => {});
    },
    //生成二维码
    code(text, width, height) {
      //这里声明为全局变量即可
      var qrcode = new QRCode(document.getElementById("qrcode"), {
        text,
        width,
        height,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
    },
    //直播链接
    handleClick(tab, event) {
      console.log(tab.name, "---tab");
      if (tab.name == "观众") {
        let val = document.getElementById("qrcode");
        if (val != null) {
          document.getElementById("qrcode").empty();
        } else {
          let url = `https://live.polyv.cn/watch/${this.channelId}`;
          setTimeout(() => {
            this.code(url, 80, 80);
          }, 500);
        }
      } else if (tab.name == "第三方推流") {
        this.getStreamingLink();
      }
    },
    toRoleSet() {
      this.handleSelect("角色设置");
      this.isShowLiveLink = false;
    },
    // 第三方推流
    getStreamingLink() {
      polyvPushUrl(this.channelId)
        .then((res) => {
          if (res.data.code == 1) {
            this.streamingLink = res.data.data.pushUrl;
          }
        })
        .catch((err) => {});
    },
    // 获取角色设置-主讲数据
    getRoleSet(channelId) {
      polyvGetTeacherInfo(channelId)
        .then((res) => {
          if (res.data.code == 1) {
            this.tableData = [];
            let data = res.data.data;
            if (!data.avatar.includes("https:")) {
              data.avatar = "https:" + data.avatar;
            }
            this.tableData.push(data);
          }
        })
        .catch((err) => {});
    },
    // 获取角色设置-助教／嘉宾数据
    getRoleSetList(channelId) {
      polyvGetAccounts(channelId)
        .then((res) => {
          if (res.data.code == 1) {
            console.log(res.data.data);
            let data = res.data.data;
            let assistantData = [];
            let guestData = [];
            data.forEach((item) => {
              if (item.role == "Assistant") {
                if (!item.avatar.includes("https:")) {
                  item.avatar = "https:" + item.avatar;
                }
                assistantData.push(item);
              }
              if (item.role == "Guest") {
                if (!item.avatar.includes("https:")) {
                  item.avatar = "https:" + item.avatar;
                }
                guestData.push(item);
              }
            });
            // 助教
            this.roleAssistantData = assistantData;
            // 嘉宾
            this.roleGuestData = guestData;
            console.log(this.roleGuestData, "<======roleGuestData");
          }
        })
        .catch((err) => {});
    },
    // 复制链接
    copyLink(link) {
      let url = link;
      let inputNode = document.createElement("input");
      inputNode.value = url;
      document.body.appendChild(inputNode);
      inputNode.select();
      document.execCommand("Copy");
      inputNode.className = "oInput";
      inputNode.style.display = "none";
      this.$message.success("复制成功");
    },
    // 角色设置
    roleSetClick(type, row) {
      // type 1 主讲 2 助教 3 嘉宾 4 添加助教 5 添加嘉宾
      switch (type) {
        case "2":
          this.roleTitle = "编辑助教";
          let avatar1 = row.avatar;
          if (avatar1.includes("https:")) {
          } else {
            avatar1 = "https:" + avatar1;
          }
          this.roleForm = {
            channelId: row.channelId,
            account: row.account,
            nickname: row.nickname,
            actor: row.actor,
            passwd: row.passwd,
            avatar: avatar1,
          };
          break;
        case "3":
          this.roleTitle = "编辑嘉宾";
          let avatar2 = row.avatar;
          if (avatar2.includes("https:")) {
          } else {
            avatar2 = "https:" + avatar2;
          }
          this.roleForm = {
            channelId: row.channelId,
            account: row.account,
            nickname: row.nickname,
            actor: row.actor,
            passwd: row.passwd,
            avatar: avatar2,
          };
          break;
        case "4":
          this.roleTitle = "添加助教";
          this.roleForm = {
            channelId: "",
            account: "",
            nickname: "",
            actor: "助教",
            passwd: "",
            avatar: "",
            role: "Assistant",
          };
          break;
        case "5":
          this.roleTitle = "添加嘉宾";
          this.roleForm = {
            channelId: "",
            account: "",
            nickname: "",
            actor: "嘉宾",
            passwd: "",
            avatar: "",
            role: "Guest",
          };
          break;
        default:
          this.roleTitle = "编辑主讲";
          let avatar = row.avatar;
          if (avatar.includes("https:")) {
          } else {
            avatar = "https:" + avatar;
          }
          this.roleForm = { ...row, avatar: avatar };
      }
      this.isShowRoleSet = true;
    },
    // 角色设置弹框-保存按钮
    roleSubmit() {
      let { roleTitle } = this;
      switch (roleTitle) {
        case "编辑助教":
          this.updateAccount();
          break;
        case "编辑嘉宾":
          this.updateAccount();
          break;
        case "添加助教":
          this.addChannelAccount();
          break;
        case "添加嘉宾":
          this.addChannelAccount();
          break;
        default:
          this.updateTeacher();
      }
    },
    handleRemove(file, fileList) {
      return this.$confirm(`确定要删除图片吗？`).then(() => {
        this.roleForm.avatar = "";
      });
    },
    // logo上传成功
    handleLogoSuccess(resData, file, fileList) {
      this.roleForm.avatar = this.$imgOssUrl + resData.data.url;
    },
    // logo上传失败
    handleLogoError(err, file, fileList) {
      this.$message.error(err.message);
    },
    // 编辑主讲
    updateTeacher() {
      let { roleForm } = this;
      updateTeacher(roleForm)
        .then((res) => {
          if (res.data.code == 1) {
            this.isShowRoleSet = false;
            this.$message.success("修改成功");
            this.getRoleSet(roleForm.channelId);
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch((err) => {});
    },
    // 编辑助教 ／ 嘉宾
    updateAccount() {
      let { roleForm } = this;
      updateAccount(roleForm)
        .then((res) => {
          if (res.data.code == 1) {
            this.isShowRoleSet = false;
            this.$message.success("修改成功");
            this.getRoleSetList(roleForm.channelId);
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch((err) => {});
    },
    // 添加助教／嘉宾
    addChannelAccount() {
      let { roleForm, channelId } = this;
      let data = {
        channelId,
        role: roleForm.role,
        nickname: roleForm.nickname,
        actor: roleForm.actor,
        passwd: roleForm.passwd,
        avatar: roleForm.avatar,
      };
      polyvAddChannelAccount(data)
        .then((res) => {
          if (res.data.code == 1) {
            this.isShowRoleSet = false;
            this.$message.success("添加成功");
            this.getRoleSetList(channelId);
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch((err) => {});
    },
    // 删除助教 ／ 嘉宾
    delAccount(row) {
      this.$confirm("确认要删除吗？")
        .then((_) => {
          deleteAccount({
            channelId: row.channelId,
            account: row.account,
          })
            .then((res) => {
              if (res.data.code == 1) {
                if (row.role == "Assistant") {
                  this.roleAssistantData = this.roleAssistantData.filter(
                    (item) => {
                      return item.account != row.account;
                    }
                  );
                } else if (row.role == "Guest") {
                  this.roleGuestData = this.roleGuestData.filter((item) => {
                    return item.account != row.account;
                  });
                }
              } else {
                this.$message.warning(res.data.message);
              }
            })
            .catch((err) => {});
        })
        .catch((_) => {});
    },
    // 获取数据统计
    getStatistic(channelId) {
      polyvStatistic(channelId)
        .then((res) => {
          if (res.data.code == 1) {
            this.statsObj = res.data.data;
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch((err) => {});
    },
    // 改变商品库开关状态
    updateProductEnabled() {
      let { channelId, goodsSwitch } = this;
      polyvUpdateProductEnabled({
        channelId,
        enabled: goodsSwitch ? "Y" : "N",
      })
        .then((res) => {
          if (res.data.code == 1) {
            this.$message.success("修改成功");
            this.getProductEnabled();
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch((err) => {});
    },
    //多选
    multipleSelect(val) {
      this.multipleSelectData = val;
    },
    // 获取商品列表
    getGoodsList() {
      let { channelId, goodsPage } = this;
      polyvProductList(
        this.$qs.stringify({
          channelId,
          page: goodsPage,
          pageSize: 10,
        })
      )
        .then((res) => {
          if (res.data.code == 1) {
            let data = res.data.data;
            this.goodsList = data;
            this.goodsTotal = data.totalItems;
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch((err) => {});
    },
    // 分页切换
    goodsChange(val) {
      this.goodsPage = val;
      this.getGoodsList();
    },
    // 获取商品库开关状态
    getProductEnabled() {
      let { channelId } = this;
      polyvProductEnabled(channelId)
        .then((res) => {
          if (res.data.code == 1) {
            this.goodsSwitch = res.data.data.enabled == "Y" ? true : false;
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch((err) => {});
    },
    //选中当前
    currentCheck(event, items) {
      let productList = this.productList;
      let newproductList = [];
      productList.map((item, index) => {
        if (item.id == items.id) {
          if (item.checked) {
            item.checked = false;
            this.checkdata = [];
          } else {
            item.checked = true;
            this.checkdata = item;
          }
        } else {
          item.checked = false;
        }
        newproductList.push(item);
      });
      this.productList = newproductList;
    },
    // 产品列表
    getProductlist() {
      let data = this.$qs.stringify({
        page_size: 999,
        page_no: 1,
      });
      productList(data)
        .then((res) => {
          if (res.data.code == 1) {
            this.productList = res.data.data.lists;
            this.productList.forEach((item) => {
              item.checked = false;
            });
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch((err) => {});
    },
    // 修改商品上下架状态
    changeProductStatus(e, row) {
      polyvProductShelf({
        channelId: row.channelId,
        productId: row.productId,
        shelf: e,
      })
        .then((res) => {
          if (res.data.code == 1) {
            this.$message.success("修改成功");
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch((err) => {});
    },
    // 上移 下移
    sortProduct(row, type) {
      polyvSortProduct({
        channelId: row.channelId,
        productId: row.productId,
        type,
      })
        .then((res) => {
          if (res.data.code == 1) {
            this.$message({
              message: type == "10" ? "上移成功" : "下移成功",
              type: "success",
            });
            this.getGoodsList();
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch((err) => {});
    },
    // 商品推送
    pushProduct(row, index) {
      // 推送禁用
      this.$set(this.goodsList.contents[index], "isPush", true);
      polyvPushProduct({
        channelId: row.channelId,
        productId: row.productId,
      })
        .then((res) => {
          if (res.data.code == 1) {
            this.$message.success("推送成功,5秒后可以继续推送");
            // 5秒后 推送启用
            setTimeout(() => {
              this.$set(this.goodsList.contents[index], "isPush", false);
            }, 5000);
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch((err) => {});
    },
    // 删除商品
    delGoods(row) {
      this.$confirm("确认要删除吗？")
        .then((_) => {
          deleteProduct({
            channelId: row.channelId,
            productId: row.productId,
          })
            .then((res) => {
              if (res.data.code == 1) {
                this.$message.success("删除成功");
                this.goodsList.contents = this.goodsList.contents.filter(
                  (item) => {
                    return item.productId != row.productId;
                  }
                );
              } else {
                this.$message.warning(res.data.message);
              }
            })
            .catch((err) => {});
        })
        .catch((_) => {});
    },
    // 编辑商品
    editProduct(row) {
      let productList = this.productList;
      let newproductList = [];
      productList.map((item, index) => {
        item.checked = false;
        newproductList.push(item);
      });
      this.productList = newproductList;
      this.isShowGoods = true;
    },
    // 添加商品保存
    goodsSubmit(formName) {
      let url = "user.php?m=polyv.addProduct";
      if (
        JSON.stringify(this.checkdata) == "{}" ||
        JSON.stringify(this.checkdata) == "[]"
      ) {
        this.$message.error("请选择产品");
      } else {
        let goodsForm = {
          cover: this.checkdata.imgs[0],
          productType: "normal",
          wxMiniprogramLink:
            "/pages/home/reveal/reveal?id=" + this.checkdata.id,
          wxMiniprogramOriginalId: "wx37c845efdd572dec",
          status: "1",
          name: this.checkdata.goodsName,
          realPrice: "0",
          linkType: "11",
        };
        polyvAddProduct({ channelId: this.channelId, data: goodsForm })
          .then((res) => {
            if (res.data.code == 1) {
              this.$message.success("添加成功!");
              this.isShowGoods = false;
              this.getGoodsList();
            } else {
              this.$message.warning(res.data.message);
            }
          })
          .catch((err) => {});
      }
    },
    // 视频库 切换
    liveHandleClick(tab, event) {
      let { channelId } = this;
      switch (tab.name) {
        case "回放列表":
          this.playType = "playback";
          this.getPlayBack(channelId);
          break;
        case "点播列表":
          this.playType = "vod";
          this.getPlayBack(channelId);
          break;
        default:
          this.getRecordFiles(channelId);
      }
    },
    // 刷新
    refresh() {
      this.getRecordFiles(this.channelId);
    },
    // 获取直播暂存列表
    getRecordFiles(channelId) {
      polyvRecordFiles(channelId)
        .then((res) => {
          if (res.data.code == 1) {
            let list = res.data.data.list;
            list.forEach((item) => {
              // 开始时间 年月日 时分秒拼接
              let startTime = item.startTime;
              let year = startTime.slice(0, 4);
              let month = startTime.slice(4, 6);
              let day = startTime.slice(6, 8);
              let hour = startTime.slice(8, 10);
              let minute = startTime.slice(10, 12);
              let second = startTime.slice(12, 14);
              item.startTime = `${year}-${month}-${day} ${hour}:${minute}:${second}`;
            });
            this.recordFilesData = list;
          }
        })
        .catch((err) => {});
    },
    // 获取回放列表 点播列表
    getPlayBack(channelId) {
      let { playType, playBackPage } = this;
      polyvPlayback(
        this.$qs.stringify({
          channelId,
          listType: playType,
          page: playBackPage,
        })
      )
        .then((res) => {
          if (res.data.code == 1) {
            let data = res.data.data;
            data.contents.forEach((item) => {
              let startTime = item.startTime;
              let year = startTime.slice(0, 4);
              let month = startTime.slice(4, 6);
              let day = startTime.slice(6, 8);
              let hour = startTime.slice(8, 10);
              let minute = startTime.slice(10, 12);
              let second = startTime.slice(12, 14);
              item.startTime = `${year}-${month}-${day} ${hour}:${minute}:${second}`;
            });
            if (playType == "playback") {
              this.playBackList = data;
            } else if (playType == "vod") {
              this.vodList = data;
            }
          }
        })
        .catch((err) => {});
    },
    // 回放列表 点播列表 分页
    playBackChange(val) {
      this.playBackPage = val;
      this.getPlayBack(this.channelId);
    },
    // 添加至回放列表
    addLiveList() {
      let { multipleSelectData } = this;
      if (multipleSelectData.length > 0) {
        this.isShowVideo = true;
      } else {
        this.$message({
          message: "请至少选中一项",
          type: "warning",
        });
      }
    },
    // 转存信息填写保存
    liveSubmit() {
      let { multipleSelectData, channelId, videoForm } = this;
      console.log(videoForm, "===videoForm");
      let fileIds = [];
      multipleSelectData.forEach((item) => {
        fileIds.push(item.fileId);
      });
      fileIds = fileIds.join(",");
      polyvConvert({
        channelId,
        fileIds,
        fileName: videoForm.name,
      })
        .then((res) => {
          if (res.data.code == 1) {
            this.isShowVideo = false;
            this.getRecordFiles(channelId);
            this.$message({
              message:
                "添加成功，回放视频转入回放列表需要一定的转码时间，请耐心等待。",
              type: "success",
            });
          } else {
            this.isShowVideo = false;
            this.$message({
              message: "视频已添加至回放列表。",
              type: "warning",
            });
          }
          this.videoForm = {
            name: "",
          };
        })
        .catch((err) => {});
    },
    // 删除暂存
    recordFilesDel() {
      let { multipleSelectData, channelId } = this;
      let sessionId = [];
      multipleSelectData.forEach((item) => {
        sessionId.push(item.channelSessionId);
      });
      sessionId = sessionId.join(",");
      this.$confirm("确认要删除吗？")
        .then((_) => {
          deleteRecord({
            channelId,
            sessionId,
          })
            .then((res) => {
              if (res.data.code == 1) {
                this.getRecordFiles(channelId);
              }
            })
            .catch((err) => {});
        })
        .catch((_) => {});
    }, // 回放列表 ／ 点播列表删除
    deletePlayback() {
      let { multipleSelectData, channelId, playType } = this;
      let videoId = [];
      multipleSelectData.forEach((item) => {
        videoId.push(item.videoId);
      });
      videoId = videoId.join(",");
      this.$confirm("确认要删除吗？")
        .then((_) => {
          deletePlayback({
            channelId,
            listType: playType,
            videoId,
          })
            .then((res) => {
              if (res.data.code == 1) {
                this.getPlayBack(channelId);
              }
            })
            .catch((err) => {});
        })
        .catch((_) => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
}
.flex-center-btw {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.flex-al-center {
  display: flex;
  align-items: center;
}
.flex-al-around {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.pointer {
  cursor: pointer;
}
.content {
  padding: 20px;
  display: flex;
  margin-bottom: 0;
  min-height: calc(100vh - 100px);
}
/* 直播左侧菜单 */
.live-left {
  width: 188px;
  height: 100%;
  background: #ecedf1;
}

.live-left .el-submenu .el-menu-item {
  width: 100%;
  min-width: inherit;
}

.live-left .el-submenu__title .icon {
  width: 17px;
  margin-right: 4px;
  display: inline-block;
}

.live-left /deep/ .el-menu-item-group__title {
  padding: 0;
}

.live-left .el-menu-item.is-active {
  background: rgba(60, 129, 230, 0.18) !important;
}

/* 直播右侧内容 */
.live-right {
  width: 100%;
  background: #fff;
  box-sizing: border-box;
}

.live-right .common-main {
  position: relative;
  padding: 40px 60px 30px 35px;
}

.common-main .com-top .title {
  font-size: 18px;
  font-weight: 500;
}

.common-main .com-top .com-btn {
  width: 90px;
  height: 35px;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  line-height: 35px;
  background: #3c81e6;
  border-radius: 3px;
}
.common-main .el-button {
  color: #409eff;
  height: auto;
  cursor: pointer;
  font-size: 14px;
  padding: 0;
  min-width: auto;
  border-radius: 4px;
  position: inherit;
  bottom: 0;
  left: 0;
  transform: none;
  background: transparent;
}
/* 直播信息 */
.live-infor {
  margin-top: 35px;
}
.live-infor .live-tips {
  color: #666;
  font-size: 16px;
  line-height: 25px;
}
.live-infor .live-list {
  color: #222;
  font-size: 16px;
  margin-top: 27px;
  line-height: 25px;
}
.live-infor .live-list span {
  color: #fe1c1c;
}
.live-infor .live-list .live-title {
  width: 110px;
  text-align: right;
  margin-right: 15px;
}
.live-infor .live-list .live-status p {
  width: 95px;
  height: 38px;
  color: #fff;
  font-size: 18px;
  background: #3c81e6;
  border-radius: 3px;
  text-align: center;
  line-height: 38px;
  display: inline-block;
}
.live-infor .live-list .live-upload {
  width: 360px;
  height: 205px;
  border-radius: 5px;
  overflow: hidden;
  position: relative;
}
.live-infor .live-list .live-upload > div,
.live-infor .live-list .live-upload .el-upload-list--picture-card,
.live-infor
  .live-list
  .live-upload
  .el-upload-list--picture-card
  .el-upload-list__item {
  width: 100%;
  height: 100%;
}
.live-infor .live-list .live-upload /deep/ .el-upload--picture-card {
  width: 360px;
  height: 205px;
  line-height: 175px;
}
.live-infor .live-list .live-upload .el-upload--picture-card i {
  font-size: 40px;
  margin-top: 55px;
}
.live-infor .live-list .live-upload .live-uptips {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 60px;
  color: #eee;
  font-size: 18px;
  padding-top: 10px;
  text-align: center;
  box-sizing: border-box;
  background: rgba(0, 0, 0, 0.5);
}
.live-uptips .sub {
  color: #bbb;
  font-size: 14px;
}
/* 角色设置 */
.role-set {
  margin-top: 40px;
}
.role-set .set-common {
  margin-bottom: 24px;
}
.role-set .set-common .set-title {
  color: #222;
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 20px;
}
.role-set .set-common .set-title span {
  color: #666;
  font-size: 14px;
  font-weight: 400;
  margin-left: 30px;
}
.role-set .set-common .set-title span i {
  margin-right: 10px;
}
.role-set .set-common .set-title .set-btn {
  width: 110px;
  height: 35px;
  color: #fff;
  font-size: 14px;
  text-align: center;
  line-height: 35px;
  display: inline-block;
  background: #3c81e6;
  border-radius: 21px;
}
/* 直播产品 */
.goods-content .goods-top {
  padding: 35px 0 30px;
  margin-bottom: 30px;
  border-bottom: 1px dashed #999;
}
.goods-content .goods-top .goods-title {
  color: #222;
  font-size: 18px;
  font-weight: 500;
  margin-right: 30px;
}
.goods-content .tips {
  color: #666;
  font-size: 14px;
  margin-left: 30px;
}
.goods-content .tips i {
  font-size: 18px;
  margin-right: 10px;
}
.goods-content .add-goods {
  margin-bottom: 30px;
}
.goods-content .add-btn {
  width: 110px;
  height: 35px;
  color: #fff;
  font-size: 14px;
  line-height: 35px;
  text-align: center;
  background: #3c81e6;
  border-radius: 21px;
}
.role-wrap .role-main .role-content .goods-half .el-input {
  width: 150px;
  margin-right: 10px;
}
.goods-half .el-dropdown {
  width: 150px;
  height: 48px;
  line-height: 48px;
  text-align: center;
  background: #fff;
  border-radius: 3px;
  margin-bottom: 30px;
  border: 1px solid #cfd8dd;
}
.goods-half .el-dropdown .el-dropdown-link {
  width: 100%;
  height: 100%;
  color: #222;
  font-size: 14px;
  display: inline-block;
}
.goods-upload .el-upload--picture-card {
  width: auto;
  height: auto;
  color: #3c81e6;
  font-size: 16px;
  border: 0 none;
  background: inherit;
  line-height: inherit;
}
.goods-wrap .tips {
  color: #666;
  width: 400px;
  font-size: 12px;
  margin-top: 6px;
  line-height: 20px;
  margin-left: 10px;
}
.goods-wrap .tips i {
  margin-right: 10px;
}

/* 弹框 */
.live-link,
.role-wrap {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  background: rgba(0, 0, 0, 0.4);
}
.live-link .link-main,
.role-wrap .role-main {
  width: 668px;
  height: 373px;
  position: absolute;
  top: 50%;
  left: 50%;
  background: #fff;
  border-radius: 8px;
  transform: translate(-50%, -50%);
}
/* 角色设置弹框 */
.role-wrap .role-main {
  height: auto;
}
.role-wrap .role-main .role-content {
  padding-top: 20px;
}
.role-wrap .role-main .role-content .el-form-item__label {
  color: #222;
  font-size: 14px;
}
.role-wrap .role-main .el-input {
  width: 408px;
}
.role-wrap .role-main .role-content .el-form-item {
  margin-bottom: 27px;
}
.role-wrap .role-main .role-btn {
  text-align: right;
  margin-right: 50px;
}
// .role-wrap .role-main .role-btn .el-form-item__content {
//   text-align: right;
//   margin-right: 50px;
// }
.role-wrap .role-main .role-btn .el-button {
  width: 100px;
  height: 43px;
  color: #fff;
  border-radius: 3px;
  background-color: #e4e4e4;
}
.role-wrap .role-main .role-btn .el-button--primary {
  border-color: #3c81e6;
  background-color: #3c81e6;
}
.role-wrap .role-main .role-upload .el-upload--picture-card {
  width: 58px;
  height: 58px;
  line-height: 65px;
  border-radius: 50%;
}
.role-wrap .role-main .role-upload .el-upload--picture-card i {
  color: #ccc;
}
.role-wrap .role-main .change-tips {
  position: absolute;
  top: -5px;
  left: 95px;
  font-size: 16px;
  color: #3c81e6;
}
.role-wrap .role-main .role-upload .tips {
  color: #666;
  width: 100%;
  font-size: 14px;
  padding-left: 12px;
}
.role-wrap .role-main .role-upload .tips i {
  font-size: 18px;
  margin-right: 10px;
}

/* 直播链接弹框 */
.live-link .link-main .link-top,
.role-wrap .role-main .role-top {
  height: 68px;
  color: #222;
  font-size: 16px;
  font-weight: 500;
  padding: 0 27px 0 35px;
  border-bottom: 1px solid #eee;
}
.live-link .link-main .link-top .el-icon-close {
  color: #999;
  font-size: 24px;
}
.live-link .link-main .link-content {
  margin: 20px 35px 0 35px;
}
.live-link .link-main .link-content .el-tabs__nav-wrap::after {
  background-color: inherit;
}
.live-link .link-main .link-content .input-list {
  color: #222;
  font-size: 14px;
  margin-top: 24px;
}
.link-content .input-list .link-label {
  width: 130px;
  text-align: right;
}
.link-content .input-list .link-input {
  flex: 1;
  font-size: 14px;
  align-items: center;
  margin: 0 15px 0 10px;
}
.link-content .input-list .link-input .el-input__inner {
  border: 0 none;
  height: 48px;
  line-height: 48px;
  background-color: #edf1f7;
}
.link-content .input-list .link-input > .span {
  margin-right: 25px;
}
.link-content .input-list .link-input > .span span {
  color: #fff;
  height: 38px;
  padding: 0 8px;
  line-height: 38px;
  border-radius: 3px;
  background: #3c81e6;
  display: inline-block;
}
.link-content .input-list .link-btn {
  font-size: 14px;
  color: #bbb;
}
.link-content .input-list .link-btn span {
  color: #3c81e6;
}
/* 数据统计 */
.stats-wrap {
  flex-wrap: wrap;
  margin-top: 40px;
}
.stats-wrap .stats-item {
  width: 268px;
  height: 138px;
  color: #222;
  font-size: 20px;
  padding: 20px 25px;
  border-radius: 8px;
  margin: 0 56px 30px 0;
  background: #eff1f5;
  box-sizing: border-box;
}
.stats-wrap .stats-item .stats-num {
  color: #333;
  font-size: 40px;
  font-weight: bold;
  line-height: 48px;
  text-align: center;
  margin-top: 16px;
}
/* 视频回放 */
.video-main {
  margin-top: 25px;
}
.video-main .el-tabs__nav {
  height: 45px;
}
.video-main .el-tabs__nav-wrap::after {
  height: 1px;
  background: #eee;
}
.video-main .el-tabs__item {
  color: #222;
  font-weight: 400;
  font-size: 18px;
}
.video-main .el-tabs__item.is-active {
  color: #3c81e6;
  font-weight: 500;
}
.video-main .top {
  margin-bottom: 30px;
}
.video-main .top .tips {
  flex: 1;
  font-size: 14px;
  color: #666;
  line-height: 20px;
}
.video-main .top .tips i {
  position: relative;
  top: 4px;
  margin-right: 10px;
}
.video-main .top .top-btn span {
  width: 105px;
  height: 35px;
  font-size: 14px;
  color: #3c81e6;
  text-align: center;
  line-height: 35px;
  background: #fff;
  border-radius: 21px;
  margin-left: 20px;
  display: inline-block;
  border: 1px solid #3c81e6;
}
.video-main .top .top-btn .top-add {
  width: 165px;
  color: #fff;
  background: #3c81e6;
}
.video-main .top .top-btn .top-del {
  color: #fe1c1c;
  border-color: #fe1c1c;
}
.video-main .video-type {
  font-size: 14px;
  color: #faad14;
  padding: 4px 10px;
  border-radius: 5px;
  background: rgba(250, 173, 20, 0.12);
  border: 1px solid rgba(250, 173, 20, 0.25);
}
.video-main .type-green {
  color: #52c41a;
  background: rgba(82, 196, 26, 0.12);
  border-color: rgba(82, 196, 26, 0.25);
}
.video-main .type-blue {
  color: #1677ff;
  background: rgba(22, 119, 255, 0.12);
  border-color: rgba(22, 119, 255, 0.25);
}
.video-main .type-purple {
  color: #b620e0;
  background: rgba(182, 32, 224, 0.12);
  border-color: rgba(182, 32, 224, 0.25);
}
.role-main .role-upload .el-form-item__content > div {
  width: 58px;
  height: 58px;
  overflow: hidden;
}
.role-main
  .role-upload
  .el-form-item__content
  > div
  .el-upload-list--picture-card,
.role-upload
  .el-form-item__content
  > div
  .el-upload-list--picture-card
  .el-upload-list__item {
  width: 58px;
  height: 58px;
  border-radius: 50%;
  border: 0 none;
}

.el-table td.el-table__cell div {
  font-size: 16px;
  line-height: 35px;
}
.main-page {
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 99;
  width: 100%;
  padding: 10px 20px;
  text-align: right;
  // background: #f8f8f8;
  box-sizing: border-box;
}

.el-select-dropdown__list {
  padding-bottom: 20px;
}

.role-content .radio-type .el-radio {
  border-radius: 3px;
  margin-right: 10px;
}
.role-content .radio-type .el-radio.is-bordered.is-checked {
  border-width: 2px;
}
.role-content .radio-type .el-radio.is-bordered .el-radio__input {
  display: none;
}
.role-content .radio-type .el-radio.is-bordered.is-checked .is-checked {
  display: block;
  position: absolute;
  bottom: 0;
  right: 0;
  width: 20px;
  height: 20px;
  background: url("/images/polyv/yes.png") no-repeat;
  background-size: cover;
}
.role-content .radio-type .el-radio .el-radio__inner {
  display: none;
}

.role-content .status-type,
.role-content .status-type .el-radio {
  overflow: hidden;
}
.el-table {
  margin-bottom: 50px;
}
.role-wrap .role-main .goods-link .el-input {
  margin-bottom: 20px;
}

.role-wrap .role-main .goods-link .el-input-group__append,
.role-wrap .role-main .goods-link .el-input-group__prepend {
  width: 110px;
  text-align: center;
  box-sizing: border-box;
}
.image-wrap {
  display: flex;
  .image {
    margin-right: 10px;
    margin-bottom: 10px;
    width: 358px;
    height: 203px;
    border-radius: 6px;
    position: relative;
    border: 1px dashed #ccc;
    /deep/ .el-image {
      width: 358px;
      height: 203px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 6px;
      .el-image__inner {
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
      }
    }
    .upload-span {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba($color: #000, $alpha: 0.4);
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0;
      transition: all 0.1s;
      border-radius: 6px;
      .upload-icon {
        color: #fff;
        font-size: 22px;
      }
    }
    &:hover {
      .upload-span {
        opacity: 1;
      }
    }
  }
}
.role-wrap .role-main .role-content /deep/ .el-upload--picture-card {
  width: 58px;
  height: 58px;
  line-height: 68px;
}
.role-wrap .role-main .role-content .image {
  width: 58px;
  height: 58px;
  position: relative;
  /deep/ .el-image {
    width: 58px;
    height: 58px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    .el-image__inner {
      width: auto;
      height: auto;
      max-width: 100%;
      max-height: 100%;
    }
  }
  .upload-span {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba($color: #000, $alpha: 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: all 0.1s;
    border-radius: 6px;
    .upload-icon {
      color: #fff;
      font-size: 22px;
    }
  }
  &:hover {
    .upload-span {
      opacity: 1;
    }
  }
}
.cloumtable {
  width: 95%;
  margin: 0px auto 30px;
}
.cloumtable tr {
  height: 35px;
  line-height: 35px;
}
.gridval {
  border-bottom: 1px solid #eee;
}
.cloumtable th {
  font-size: 14px;
}
.cloumtable td {
  padding: 10px 0;
  font-size: 12px;
  vertical-align: middle;
}
.cptp {
  width: 88px;
  height: 88px;
  border-radius: 18px;
}
.grid {
  background: #edf1f7;
}
.goods-wrap .role-main /deep/ .el-scrollbar__wrap {
  overflow-x: hidden;
}
.video-main /deep/ .el-tabs__content {
  min-height: 640px;
}
</style>